/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbol, DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {DasUBootStatics} from "../../utils/DasUBootStatics";


export class ProxySymbol extends DasUBootSymbol {


    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName);
        this.sprite.removeChild(this.frame);
    }

    protected setSpriteTexture(textureName?:string) {
        super.setSpriteTexture("none");
    }

    resize(scale:number, offset:number, duration:number, customEase?:any):gsap.core.Timeline {
        return gsap.timeline();
    }

    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        return gsap.timeline();
    }
}